import styled from 'styled-components'

export const Inverse = styled.div `
  background-color: white;
  color: blue;
`
export const InverseH1 = styled.h1 `
  padding-top:45px;
  color: black;
  text-transform: uppercase;
`
export const InverseH3 = styled.h3 `
  color: black;
  text-transform: uppercase;
  padding-top: 15px;
  padding-bottom: 15px;
  letter-spacing: 5px;
`
export const InverseP = styled.p `
  font-weight: 100;
  font-size: 14px;
  color: black;
  letter-spacing: 2px;
`


// WEBPACK FOOTER //
// /src/components/OnePager/AboutStyle.js